import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../maps/colors";

const WrapperStyled = styled.div`
  position: absolute;
  height: fit-content;
  width: fit-content;
  display: grid;
  justify-content: center;
  align-content: center;

  img {
    height: 90%;
    width: 70%;
    object-fit: cover;
  }
`;

const Modal = (props) => {
  const { show, onClose, layers, products } = props;

  if (!show) return null; // Do not render modal if show is false

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {" "}
        {/* Prevent close on inner click */}
        <h4>Layers:</h4>
        <ul>
          {layers.map((layer, index) => {
            const product = products[layer.productId];

            return (
              <li key={index}>
                Product ID: {layer.productId}
                {product && product.imageUrl && (
                  <div>
                    <img
                      src={product.imageUrl}
                      alt={`Product ${product.name}`}
                      style={{ maxWidth: "100px", height: "auto" }}
                    />
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

const Placement = ({ item, color, products }) => {
  if (Object.keys(products).length > 0) {
   }
  const { boundingBoxPr, label, layers } = item;

  // State to track whether layers are visible or not
  const [showModal, setShowModal] = useState(false);

  // Calculate number of layers
  const layersCount = layers && layers.length > 0 ? layers.length : 0;

  let borderStyle = "solid";
  let borderRadius = "50%";
   switch (label) {
    case "six_pack":
      borderRadius = "20%";
      break;
    case "dash_circle":
      borderStyle = "dotted";
      break;
    case "circle":
      break;
    case "cereal":
      borderRadius = 0;
      break;
    default:
      borderRadius = 0;
      break;
  }

  let left = `${boundingBoxPr.xMin}%`;
  let top = `${boundingBoxPr.yMin}%`;
  let width = `${boundingBoxPr.xMax - boundingBoxPr.xMin}%`;
  let height = `${boundingBoxPr.yMax - boundingBoxPr.yMin}%`;

  const circleColor = color ? color : colors.SUCCESS_GREEN;

  // Handle click event to open the modal
  const handleClick = () => {
    setShowModal(true);
  };

  // Handle close modal event
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <WrapperStyled
        title={
          products?.[item.productId]?.name ||
          products?.[item.layers?.[0].productId]?.name ||
          "Product"
        }
        style={{
          left: left,
          top: top,
          width: width,
          height: height,
          border: `1px ${borderStyle} ${circleColor}`,
          borderRadius: borderRadius,
        }}
        onClick={handleClick} // Add click handler
      >
        {(products?.[item.productId]?.imageUrl ||
          products?.[item.layers?.[0].productId]?.imageUrl) && (
          <img
            src={
              products?.[item.productId]?.imageUrl ||
              products?.[item.layers?.[0].productId]?.imageUrl
            }
            alt=""
          />
        )}

        {/* Display number of layers if applicable */}
        {layersCount > 0 && (
          <div
            style={{
              position: "absolute",
              top: "5px",
              right: "5px",
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              padding: "5px",
              fontSize: "12px",
              fontWeight: "bold",
              opacity: 0.3,
            }}
          >
            {layersCount}
          </div>
        )}
      </WrapperStyled>

      {/* Render the modal when showModal is true */}
      <Modal
        show={showModal}
        onClose={closeModal}
        layers={layers}
        products={products}
      />
    </div>
  );
};

export default Placement;
